export const SLICE_CHECK_IN = 'SLICE_CHECK_IN'

export const CHECK_IN = `${SLICE_CHECK_IN}/checkIn`
